import lodashGet from 'lodash/get';
import { api } from '@/api/api';
import { apis } from '@/config';
class IMTeamApiImpl {
    constructor() {
        this.name = apis.imTeamApiImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    getUrl(url) {
        return this.systemApi.getUrl(url);
    }
    parseResult(res) {
        return res.data;
    }
    catchError(reason) {
        return reason;
    }
    createTeam(option, blockedError = true) {
        let $request = this.httpApi.post(this.getUrl('createTeam'), option).then(res => {
            if (lodashGet(res, 'data.code', 999) !== 0) {
                throw new Error(lodashGet(res, 'data.message', '创建失败'));
            }
            return res.data;
        });
        if (blockedError) {
            $request = $request.catch(this.catchError);
        }
        return $request;
    }
    removeTeam(option) {
        return this.httpApi.post(this.getUrl('removeTeam'), option).then(this.parseResult).catch(this.catchError);
    }
    addMember(option, blockedError = true) {
        let $request = this.httpApi.post(this.getUrl('addMember'), option).then(res => {
            if (lodashGet(res, 'data.code', 999) !== 0) {
                throw new Error(lodashGet(res, 'data.message', '添加失败'));
            }
            return res.data;
        });
        if (blockedError) {
            $request = $request.catch(this.catchError);
        }
        return $request;
    }
    removeMember(option) {
        return this.httpApi.post(this.getUrl('removeMember'), option).then(this.parseResult).catch(this.catchError);
    }
    addManager(option) {
        return this.httpApi.post(this.getUrl('addManager'), option).then(this.parseResult).catch(this.catchError);
    }
    removeManager(option) {
        return this.httpApi.post(this.getUrl('removeManager'), option).then(this.parseResult).catch(this.catchError);
    }
    changeOwner(option) {
        return this.httpApi.post(this.getUrl('changeOwner'), option).then(this.parseResult).catch(this.catchError);
    }
    quitTeam(option) {
        return this.httpApi.post(this.getUrl('quitTeam'), option).then(this.parseResult).catch(this.catchError);
    }
    updateProfile(option) {
        return this.httpApi.post(this.getUrl('updateProfile'), option).then(this.parseResult).catch(this.catchError);
    }
    updateName(option) {
        return this.httpApi.post(this.getUrl('updateName'), option).then(this.parseResult).catch(this.catchError);
    }
    queryProfile(team_id, ope = 0) {
        const url = this.getUrl('queryProfile');
        return this.httpApi.get(url, { team_id, ope }).then(this.parseResult).catch(this.catchError);
    }
    queryDetailProfile(team_id) {
        const url = this.getUrl('queryDetailProfile');
        return this.httpApi.get(url, { team_id }).then(this.parseResult).catch(this.catchError);
    }
    muteMessage(option) {
        console.log('[im-team] get mute mesage ', this.getUrl('muteMessage'));
        return this.httpApi.post(this.getUrl('muteMessage'), option).then(this.parseResult).catch(this.catchError);
    }
    memberBelongs(accid) {
        const url = this.getUrl('memberBelongs');
        return this.httpApi.get(url, { accid }).then(this.parseResult).catch(this.catchError);
    }
    async toggleMute(options) {
        const url = this.getUrl('toggleSessionMute');
        return this.httpApi.post(url, options).then(this.parseResult).catch(this.catchError);
    }
    async addLater(options) {
        const url = this.getUrl('addSessionLater');
        return this.httpApi.post(url, options).then(this.parseResult).catch(this.catchError);
    }
    async completeLater(session_id) {
        const url = this.getUrl('completeSessionLater');
        return this.httpApi.post(url, { session_id }).then(this.parseResult).catch(this.catchError);
    }
    async syncLater() {
        const url = this.getUrl('syncSessionLater');
        return this.httpApi.get(url).then(this.parseResult).catch(this.catchError);
    }
    async toggleTeamPublic(options) {
        const url = this.getUrl('toggleTeamPublic');
        return this.httpApi.post(url, options).then(this.parseResult).catch(this.catchError);
    }
    async searchTeamPublic(tid) {
        const url = this.getUrl('searchTeamPublic');
        return this.httpApi.get(url, { tid }).then(this.parseResult).catch(this.catchError);
    }
}
const imTeamApiImpl = new IMTeamApiImpl();
api.registerLogicalApi(imTeamApiImpl);
export default imTeamApiImpl;
